import React, { createContext, useContext, useState } from 'react';
import {fetchStudentProfile} from '../api/studentApi'; 

// 1. Create the Context channel
const UserContext = createContext(null);

// 2. Create the custom Provider component
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        // 🌟 LAZY INITIALIZATION: Reads from localStorage exactly once during initial app boot
        try {
            const savedUser = localStorage.getItem('user');
            return savedUser ? JSON.parse(savedUser) : null;
        } catch (error) {
            console.error("Failed to parse user data from localStorage:", error);
            return null;
        }
    });

    // 3. Define a unified login/update handler
    const loginUser = (userData) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    // 4. Define a clear/logout handler
    const logoutUser = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('selected_subject');
    };

    const triggerUserUpdate = async () => {
        const response = await fetchStudentProfile();
        if (response && response.data) {
            setUser(response.data);
            localStorage.setItem('user', JSON.stringify(response.data));
        } else {
            console.error("Failed to fetch updated user profile.");
        };
    };

    return (
        <UserContext.Provider value={{ user, setUser, loginUser, logoutUser, triggerUserUpdate }}>
            {children}
        </UserContext.Provider>
    );
};

// 5. Create a custom hook for rapid injection into your components
export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be utilized inside a valid UserProvider wrapper block');
    }
    return context;
};